const aiFour = [
  {
        "name": "豆包 MarsCode",
        "url": "https://www.marscode.cn/", // 暂无公开独立官网，保留空值
        "icon": "images/db-ai-logo.jpg", // 暂无公开LOGO地址，保留空值
        "description": "豆包旗下的编程助手，可能用于辅助编程工作，提升编码效率。"
    },
    {
        "name": "通义灵码",
        "url": "https://tongyi.aliyun.com/lingma/",
        "icon": "images/tongyi-logo.png",
        "description": "基于阿里云通义大模型，提供代码智能生成功能，助力软件开发与编程。"
    },
    {
        "name": "Cursor",
        "url": "https://www.cursor.so",
        "icon": "images/cursor.jpg",
        "description": "使用GPT-4编写代码，借助先进的语言模型能力实现代码编写。"
    },
    {
        "name": "BerriAI",
        "url": "https://berri.ai", // 假设官网地址（需根据实际情况验证）
        "icon": "images/berri.jpg", // 假设LOGO地址（需根据实际情况验证）
        "description": "能够连接用户数据，并在几分钟内建立生成相关内容或模型，便于快速数据处理与应用搭建。"
    },
    {
        "name": "AutoRegex",
        "url": "https://www.autoregex.ai", // 假设官网地址（需根据实际情况验证）
        "icon": "images/autoregex.jpg", // 假设LOGO地址（需根据实际情况验证）
        "description": "利用人工智能更轻松地创建正则表达式，简化文本模式匹配规则的生成过程。"
    },
    {
        "name": "Code Snippets",
        "url": "", // 通常为VSCode插件或集成功能，无独立官网
        "icon": "", // 无独立LOGO，保留空值
        "description": "由GPT-4驱动，用于生成VSCode的代码片段，方便开发者快速获取代码示例。"
    },
    {
        "name": "HeyCLI",
        "url": "https://heycli.com", // 假设官网地址（需根据实际情况验证）
        "icon": "images/heycli.png", // 假设LOGO地址（需根据实际情况验证）
        "description": "将自然语言翻译成终端命令，降低用户对复杂命令行操作的学习成本。"
    },
    {
        "name": "Bifrost",
        "url": "https://bifrost.ai", // 假设官网地址（需根据实际情况验证）
        icon: "images/bifrost.png", // 假设LOGO地址（需根据实际情况验证）
        "description": "将Figma设计自动转化为干净的代码或其他目标格式，实现设计到开发的高效转换。"
    },
    {
      "name": "SpellBox",
      "url": "https://www.spellbox.app/",
      icon: "images/spellbox.png",
      "description": "人工智能编程助手，应用于编程辅助场景，提供代码智能生成功能"
    },
    {
      "name": "Debuild",
      "url": "https://debuild.app/",
      icon: "images/debuild.png",
      "description": "快速构建网络应用程序的工具，能够显著提升开发效率"
    },
    {
      "name": "AirOps",
      "url": "https://www.airops.com/",
      icon: "images/airops.jpg",
      "description": "使用强大的配方集编写SQL和文档的工具，提供智能生成SQL查询的功能"
    },
    {
      "name": "AI Query",
      "url": "https://aiquery.co/",
      icon: "images/aiquery.jpg",
      "description": "在几秒钟内用人工智能生成SQL查询的工具"
    },
    {
      "name": "HTTPie AI",
      "url": "https://httpie.io/ai",
      icon: "images/httpie.jpg",
      "description": "一种与API互动的新方式，简化API调用过程"
    },
    {
      "name": "Replit",
      "url": "https://replit.com/",
      icon: "images/replit.jpg",
      "description": "用人工智能加速编码的工具，提供智能编码辅助和协作开发功能"
    },
    {
      "name": "ExplainDev",
      "url": "https://app.explain.dev/",
      icon: "images/explain.jpg",
      "description": "根据上下文回答问题的代码解释器"
    },
    {
      "name": "Codeball",
      "url": "https://codeball.ai/",
      icon: "images/codeball.png",
      "description": "人工智能驱动的代码审查工具"
    },
    {
      "name": "What The Diff",
      "url": "https://whatthediff.ai/",
      icon: "images/whatthediff.png",
      "description": "由人工智能驱动的代码审查助手"
    },
    {
      "name": "Ask Command",
      "url": "https://askcommand.com/",
      icon: "images/askcommand.jpg",
      "description": "人工智能驱动的开发者助手"
    },
    {
      "name": "PLZ-CLI",
      "url": "https://plz-cli.vercel.app/",
      icon: "images/plz-cli.png",
      "description": "用自然语言查找终端命令的工具"
    },
    {
      "name": "Fitten Code",
      "url": "https://www.fitten.com/",
      icon: "images/fitten.png",
      "description": "自动生成代码并帮助调试的工具"
    },
    {
      "name": "AI Data Side",
      "url": "https://www.aidataside.com/",
      icon: "images/aidataside.jpg",
      "description": "AI编写SQL代码的工具"
    },
    {
      "name": "Tabnine",
      "url": "https://www.tabnine.com/",
      icon: "images/tabnine.png",
      "description": "AI代码助手，提供代码补全和智能提示功能"
    },
    {
      "name": "Codeium",
      "url": "https://www.codeium.com/",
      icon: "images/codeium.jpg",
      "description": "人工智能编码及检索工具"
    },
    {
      "name": "CodiumAI",
      "url": "https://www.codium.ai/",
      icon: "images/codium.jpg",
      "description": "AI代码测试工具"
    },
    {
      "name": "Codiga",
      "url": "https://www.codiga.io/",
      icon: "images/codiga.png",
      "description": "AI代码实时分析工具"
    },
    {
      "name": "Warp.AI",
      "url": "https://www.warp.dev/ai",
      icon: "images/warp.png",
      "description": "与终端完全集成的AI工具"
    },
    {
      "name": "Safurai",
      "url": "https://www.safurai.com/",
      icon: "images/safurai.png",
      "description": "基于人工智能的IDE扩展工具"
    },
    {
      "name": "brancher.ai",
      "url": "https://www.brancher.ai/",
      icon: "images/brancher.png",
      "description": "无代码平台，可以扩展终端功能"
    },
    {
      "name": "GitHub Copilot",
      "url": "https://github.com/features/copilot",
      icon: "images/githubassets.png",
      "description": "人工智能配对程序员工具"
    },
    {
      "name": "Akkio",
      "url": "https://www.akkio.com/",
      icon: "images/akkio.png",
      "description": "易于使用、可扩展和负担得起的无代码平台"
    },
    {
      "name": "Browse AI",
      "url": "https://www.browse.ai/",
      icon: "images/browse.png",
      "description": "监控任何网页的变化的工具"
    },
    {
      "name": "Copilot X",
      "url": "https://github.com/features/preview/copilot-x",
      icon: "images/githubassets.jpg",
      "description": "GitHub和OpenAI合作开发的编程辅助工具"
    },
    {
      "name": "Coze",
      "url": "https://www.coze.com/",
      icon: "images/coze.png",
      "description": "AI聊天机器人构建平台"
    },
    {
      "name": "Devv AI",
      "url": "https://devv.ai/",
      icon: "images/devv.png",
      "description": "输入编程问题并让AI来解答的工具"
    },
    {
      "name": "代码小浣熊",
      "url": "https://code-raccoon.github.io/",
      icon: "images/coderaccoon.png",
      "description": "专为开发者设计的AI驱动搜索引擎"
    },
    {
      "name": "GitFluence",
      "url": "https://gitfluence.com/",
      icon: "images/gitfluence.png",
      "description": "AI驱动的解决方案，可帮助快速构建和部署软件"
    },
    {
      "name": "Zion",
      "url": "https://www.zion.io/",
      icon: "images/zion.png",
      "description": "零代码开发平台"
    },
    {
      "name": "MarsX",
      "url": "https://www.marsx.io/",
      icon: "images/marsx.jpg",
      "description": "改变软件开发的游戏规则"
    },
    {
      "name": "Fig",
      "url": "https://fig.io/",
      icon: "images/fig.jpg",
      "description": "下一代命令行工具"
    },
    {
      "name": "Visual Studio Code",
      "url": "https://code.visualstudio.com/",
      icon: "images/visualstudio.png",
      "description": "自信地编写代码的工具"
    },
    {
      "name": "bloop",
      "url": "https://bloop.ai/",
      icon: "images/bloop.png",
      "description": "构建服务器和CLI工具"
    },
    {
      "name": "Ghostwriter",
      "url": "https://replit.com/site/ghostwriter",
      icon: "images/replit.jpg",
      "description": "在线编程IDE"
    },
    {
      "name": "Bito",
      "url": "https://bito.ai/",
      icon: "images/bito.jpg",
      "description": "高效的编程辅助功能"
    },
    {
      "name": "Hacker AI",
      "url": "https://hacker-ai.ai/",
      icon: "images/hacker.jpg",
      "description": "由人工智能驱动的代码审核器"
    },
    {
      "name": "Refraction",
      "url": "https://www.refraction.dev/",
      icon: "images/refraction.png",
      "description": "利用人工智能学习、改进和生成代码的工具"
    },
    {
      "name": "CodeGeeX",
      "url": "https://codegeex.cn/",
      icon: "images/codegeex.png",
      "description": "智能编程助手"
    },
    {
      "name": "Tabby",
      "url": "https://tabby.tabbyml.com/",
      icon: "images/tabbytabbyml.jpg",
      "description": "开源、自主托管的AI编码助手"
    },
    {
      "name": "CODEFUSE",
      "url": "https://codefuse.alipay.com/",
      icon: "images/codefuse.png",
      "description": "让研发变得更简单的工具"
    },
    {
      "name": "iFlyCode",
      "url": "https://iflycode.com/",
      icon: "images/iflycode.png",
      "description": "智能编程助手"
    },
    {
      "name": "腾讯云AI代码助手",
      "url": "https://cloud.tencent.com/product/taco",
      icon: "images/cloud.jpg",
      "description": "代码智能诊断、补全工具"
    },
    {
      "name": "Plandex",
      "url": "https://plandex.ai/",
      icon: "images/plandex.png",
      "description": "用于复杂任务管理和规划的工具"
    }
  ]

  export default aiFour
